import React, { Component, Fragment } from 'react';
import './stage2-new.css';
import { updateObject } from "../../js/actions/index";
import store from "../../js/store/index";
import { VisibilityFilters } from "../../js/constants/action-types";
import { setVisibilityFilter } from "../../js/actions/index";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo } from '@fortawesome/free-solid-svg-icons'
import Form from 'react-bootstrap/Form'
import { default as NumberFormat } from 'react-number-format';

function mapDispatchToProps(dispatch) {
  return {
    updateObject: article => dispatch(updateObject(article)),
  };
}

class Stage2New extends Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = { appState: store.getState(), nextButtonClass: '', subheaderText: 'Help us find the right property for you' };
    this.handleChange = this.handleChange.bind(this)
    this.gotoStage1 = this.gotoStage1.bind(this)
    this.gotoStage3 = this.gotoStage3.bind(this)
  }

  componentDidMount() {
    if (this.state.appState.whyPad.newCustomer.existingCustomer === "1") {
      this.setState({ subheaderText: 'Thanks for coming back, help us fill in the gaps....'})
    }
    if (this.state.appState.whyPad.newCustomer.houseDetached === "" && this.state.appState.whyPad.newCustomer.houseSemi === "" && this.state.appState.whyPad.newCustomer.houseTerrace === "" &&
        this.state.appState.whyPad.newCustomer.bungalow === "" && this.state.appState.whyPad.newCustomer.flatApartment === "" && this.state.appState.whyPad.newCustomer.other === "") {
      this.setState({ nextButtonClass: 'disabledButton' })
    } else {
      this.setState({ nextButtonClass: 'activeButton' })
    }
  }

  handleChange(event) {
    if (this.state.appState.checkArray.indexOf(event.target.name) >= 0) {
      this.updateCheckbox(event.target.name, event.target.value);
    } else {
      this.state.appState.whyPad.newCustomer[event.target.name] = event.target.value;
      this.setState({ [event.target.name]: event.target.value })
    }

    if ((this.state.appState.whyPad.newCustomer.houseDetached === "" && this.state.appState.whyPad.newCustomer.houseSemi === "" && this.state.appState.whyPad.newCustomer.houseTerrace === "" &&
        this.state.appState.whyPad.newCustomer.bungalow === "" && this.state.appState.whyPad.newCustomer.flatApartment === "" && this.state.appState.whyPad.newCustomer.other === "") &&
        this.state.appState.whyPad.newCustomer.beds === "" || this.state.appState.whyPad.newCustomer.priceFrom === "" || this.state.appState.whyPad.newCustomer.priceTo === "") {
      this.setState({ nextButtonClass: 'disabledButton' })
    } else {
      this.setState({ [event.target.name]: event.target.value, nextButtonClass: 'activeButton' })
    }

    console.log(this.state);
  }

  updateCheckbox(_name, _value) {
    this.setState({ _name: _value })

    if (this.state.appState.whyPad.newCustomer[_name] === parseInt(_value)) {
      this.state.appState.whyPad.newCustomer[_name] = "";
    } else {
      this.state.appState.whyPad.newCustomer[_name] = parseInt(_value);
    }
  }

  gotoStage1() {
    store.dispatch(setVisibilityFilter(VisibilityFilters.SHOW_STAGE1))
  }

  gotoStage3() {
    store.dispatch(setVisibilityFilter(VisibilityFilters.SHOW_STAGE3))
  }

  render() {
    return (
      <Fragment>
        <div className="row valFormWidth" style={{ background: 'transparent', padding: '20px 30px', opacity: '0.95', margin: '0 auto' }}>
          <div className="row pageHeader">
              <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: '10px', paddingLeft: '0px'}}>
                  <label style={{fontWeight: 'bold', marginBottom: '0px'}}>Tell us more about your move</label>
              </div>
          </div>
          <div className="row pageSubHeader">
            <div className="col-md-12 col-sm-12 col-xs-12" style={{ paddingBottom: '10px', paddingLeft: '0px'}}>
              <label style={{ fontWeight: 'bold' }}>{this.state.subheaderText}</label>
            </div>
          </div>
          <div style={{ background: 'white', textAlign: 'center', border: '1.1px solid lightgray', borderRadius: '16px', marginTop: '15px', width: '100%' }}>
            <Form>
              <div className="row" style={{ margin: '0px', position: 'relative' }}>
                <img className="imageStyle" src={require("../../assets/images/stage2New.png")}></img>
                <p onClick={() => { this.gotoStage1() }} className="backButton"><FontAwesomeIcon icon={faUndo}/></p>
              </div>
              <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px', display: 'inline' }}>
                <p style={{ marginBottom: '10px' }}>What sort of property are you looking for?</p>
              </div>
              <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto', color: 'rgb(64, 22, 99)' }}>
                {['checkbox'].map((type) => (
                  <div key={`default-${type}`} style={{ display: 'flex', marginTop: '5px', width: '100%' }}>
                    <div className="col-sm-6" style={{ textAlign: 'left' }}>
                      <Form.Check style={{ marginBottom: '5px' }} type={type} id='1' label='House - Detached' checked={this.state.appState.whyPad.newCustomer.houseDetached === 1 ? true : false} name="houseDetached" value="1" onChange={this.handleChange}/>
                      <Form.Check style={{ marginBottom: '5px' }} type={type} id='2' label='House - Semi Detached' checked={this.state.appState.whyPad.newCustomer.houseSemi === 1 ? true : false} name="houseSemi" value="1" onChange={this.handleChange}/>
                      <Form.Check style={{ marginBottom: '5px' }} type={type} id='3' label='House - Terrace' checked={this.state.appState.whyPad.newCustomer.houseTerrace === 1 ? true : false} name="houseTerrace" value="1" onChange={this.handleChange}/>
                    </div>
                    <div className="col-sm-6" style={{ textAlign: 'left' }}>
                      <Form.Check style={{ marginBottom: '5px' }} type={type} id='4' label='Bungalow' checked={this.state.appState.whyPad.newCustomer.bungalow === 1 ? true : false} name="bungalow" value="1" onChange={this.handleChange}/>
                      <Form.Check style={{ marginBottom: '5px' }} type={type} id='5' label='Flat/Apartment' checked={this.state.appState.whyPad.newCustomer.flatApartment === 1 ? true : false} name="flatApartment" value="1" onChange={this.handleChange}/>
                      <Form.Check type={type} id='6' label='Other' checked={this.state.appState.whyPad.newCustomer.other === 1 ? true : false} name="other" value="1" onChange={this.handleChange}/>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row" style={{ margin: '30px auto 0px', color: '#401663', width: '80%', fontWeight: 'bold' }}>
                <p style={{ marginBottom: '10px' }}>Number of Bedrooms?</p>
              </div>
              <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto' }}>
                <select name="title" style={{ top: '2px', fontSize: '14px', minHeight: '38px', width: '100%', paddingLeft: '.83333em',  border: '1px solid lightgray', borderRadius: '12px' }} value={this.state.appState.whyPad.newCustomer.beds} name="beds" onChange={this.handleChange}>
                  <option value="">Please select an option</option>
                  <option value="Studio">Studio</option>
                  <option value="1 Bed">1 Bed</option>
                  <option value="2 Beds">2 Beds</option>
                  <option value="3 Beds">3 Beds</option>
                  <option value="4 Beds">4 Beds</option>
                  <option value="5 Beds">5 Beds</option>
                  <option value="6 Beds">6 Beds</option>
                  <option value="7+ Beds">7+ Beds</option>
                </select>
              </div>
                <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px' }}>
                <p style={{ marginBottom: '10px' }}>What price range are you interested in?</p>
              </div>
              <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto' }}>
              <NumberFormat className="form-control searchBoxText col-md-6" inputmode="numeric" value={this.state.appState.whyPad.newCustomer.priceFrom} type={'text'} thousandSeparator={true} prefix={'£'} onChange={this.handleChange} name="priceFrom" style={{ borderRadius: '12px', marginBottom: '10px' }}/>
                {/* <input className="form-control searchBoxText col-md-6" placeholder="Price from" type="text" style={{ borderRadius: '12px', marginBottom: '10px' }} name="priceFrom" value={this.state.appState.whyPad.newCustomer.priceFrom} onValueChange={this.handleChange} onChange={this.handleChange}></input> */}
                <NumberFormat className="form-control searchBoxText col-md-6" inputmode="numeric" value={this.state.appState.whyPad.newCustomer.priceTo} type={'text'} thousandSeparator={true} prefix={'£'} onChange={this.handleChange} name="priceTo" style={{ borderRadius: '12px' }}/>
                {/* <input className="form-control searchBoxText col-md-6" placeholder="Price to" type="text" style={{ borderRadius: '12px' }} name="priceTo" value={this.state.appState.whyPad.newCustomer.priceTo} onChange={this.handleChange}></input> */}
              </div>
              <div className="row" style={{ width: '50%', margin: '40px auto 0px', borderRadius: '32px' }} className={this.state.nextButtonClass}>              
                <div onClick={() => { this.gotoStage3() }} className="form-control" style={{ borderRadius: '32px', borderLeft: 'none', marginBottom: '20px', height: '50px', paddingTop: '10px', background: 'transparent' }}>
                  <a style={{ color: 'white', fontWeight: 'bold' }} type="button">NEXT</a>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Stage2New;